<div class="popover" [ngStyle]="{ display: show ? 'block' : 'none' }" #popover>
  <div class="popover__arrow"></div>

  <div class="popover__content">
    <ng-content></ng-content>
  </div>
</div>
